<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <b style="line-height:1.5;">
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">
              <img :src="images.jsg">
              <br>
            </span>
          </u>
        </b>
      </p>
      <p>
        <b style="line-height:1.5;">
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">
              <br>
            </span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:18px;font-family:宋体;">
          <strong>Si Metal #553 #441 #3303 #2202</strong>
        </span>
        <span style="font-size:18px;font-family:Arial;">
          <strong>&nbsp;</strong>
        </span>
        <b style="line-height:1.5;">
          <span style="font-size:16.0pt;font-family:Arial;">
            #553 #441
            #3303 #2202
          </span>
        </b>
      </p>
      <p></p>
      <table
        border="1"
        cellspacing="0"
        cellpadding="0"
        width="100%"
        style="width:100%;border:none;"
      >
        <tbody>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:宋体;">Spec</span>
                <span style="font-size:10.0pt;font-family:Arial;"></span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">Si</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">Fe</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">Al</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">Ca</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">553</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">&gt;98.5%</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">≤0.5%</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">≤0.5%</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">≤0.3%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">441</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">&gt;99%</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">≤0.4%</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">≤0.4%</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">≤0.1%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">2202</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">&gt;99%</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">≤0.2%</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">≤0.2%</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">≤0.02%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">3303</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">&gt;99%</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">≤0.3%</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">≤0.3%</span>
              </p>
            </td>
            <td width="21%" valign="top" style="border:solid windowtext 1.0pt;">
              <p>
                <span style="font-size:10.0pt;font-family:Arial;">≤0.03%</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        jsg: require("../../../assets/img/common/jsg.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/product/jsg.vue